'use strict';

/**
 * @ngdoc function
 * @name thothAppApp.controller:ClientsGroupShowCtrl
 * @description
 * # ClientShowCtrl
 * Controller of the thothAppApp
 */
angular.module('thothApp.controllers')
  .controller('ClientsGroupShowCtrl', [
    '$scope', '$state', '$stateParams', 'ClientsGroup','$rootScope', function ($scope, $state, $stateParams, ClientsGroup, $rootScope) {

      $scope.userIsAdmin = function() {
        if ('apiUser' in $window.localStorage) {
          const apiUser = JSON.parse($window.localStorage.apiUser);
          if(apiUser.employee) {
            return apiUser.employee.is_admin_group;
          } else {
            return false;
          }
        } else {
          return false;
        }
      }
      console.log( $scope.userIsAdmin)
      $scope.clients_group = {};
      ClientsGroup.find($stateParams.clientGroupId).then(function(response) {
        $scope.clients_group = response.data.client_group;
      }, function(error) {
        ClientsGroup.error(error);
      });
  }]);
